import { motion } from "framer-motion";
import { FOOD_MENU, BAR_IMAGE, buildWhatsappURL } from "@/data/site";
import { Sparkles } from "lucide-react";

export default function FoodBarSection() {
  return (
    <section id="food" data-testid="food-bar-section" className="relative py-24 md:py-32 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-end mb-10">
          <div className="lg:col-span-7">
            <div className="text-xs uppercase tracking-[0.22em] text-[#f5f0ea] font-semibold">བཀྲ་ཤིས་བདེ་ལེགས · Tashi Delek</div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold mt-3 tracking-tighter text-white">
              A bar that <span className="text-[#A7D38B] italic">hums</span> with the Himalayas.
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-neutral-400">
              Tibetan-inspired plates, mountain-fermented brews and a low-lit
              room that forgives every late-night confession.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-5">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative lg:col-span-5 rounded-3xl overflow-hidden min-h-[420px] border border-white/5"
            data-testid="bar-hero"
          >
            <img
              src={BAR_IMAGE}
              alt="Tibetan-inspired bar"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent" />
            <div className="relative p-6 h-full flex flex-col justify-end">
              <span className="inline-flex w-fit items-center gap-1.5 rounded-full bg-[#62794d]/20 border border-[#A7D38B]/30 text-[#A7D38B] text-[11px] px-2.5 py-1">
                <Sparkles size={12} /> Bar open · 4PM – 1AM
              </span>
              <h3 className="font-display text-3xl font-bold mt-3 text-white">The Nomikai Bar</h3>
              <p className="text-sm text-neutral-300 mt-1">
                Chhaang, tongba & Himalayan-forward pours.
              </p>
              <a
                href={buildWhatsappURL({ message: "I'd like to reserve a table at the bar." })}
                target="_blank"
                rel="noreferrer"
                data-testid="reserve-bar-btn"
                className="mt-5 inline-flex items-center w-fit rounded-full bg-[#f5f0ea] text-neutral-900 px-4 py-2 text-xs font-semibold hover:bg-white transition"
              >
                Reserve a table
              </a>
            </div>
          </motion.div>

          <div className="lg:col-span-7 grid grid-cols-2 md:grid-cols-3 gap-4">
            {FOOD_MENU.map((m, i) => (
              <motion.div
                key={m.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.05 }}
                whileHover={{ y: -4 }}
                className="rounded-2xl overflow-hidden bg-neutral-900 border border-white/5 hover:border-[#A7D38B]/40 transition-colors"
                data-testid={`menu-${m.title.toLowerCase().replace(/\s+/g, "-")}`}
              >
                <div className="aspect-square overflow-hidden">
                  <img
                    src={m.image}
                    alt={m.title}
                    loading="lazy"
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
                  />
                </div>
                <div className="p-3">
                  <div className="flex items-center justify-between">
                    <div className="font-semibold text-sm text-white">{m.title}</div>
                    <div className="text-[#f5f0ea] text-sm font-semibold">₹{m.price}</div>
                  </div>
                  <div className="text-[11px] uppercase tracking-widest text-neutral-500 mt-0.5">
                    {m.type}
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
